export const socialsData = {
    github: 'https://github.com/abhilashsandi',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/abhilashsandi',
    instagram: 'https://www.instagram.com/abhilashsandi',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/abhilashsandi'
}